import { FormattedMessage } from 'dibs-react-intl';
import { Link } from 'dibs-elements/exports/Link';

import styles from '../styles/catalogError.scss';

export const CatalogError = () => {
    const header = (
        <FormattedMessage id="CatalogError.header" defaultMessage="Sorry, an error has occurred." />
    );

    const contact = <FormattedMessage id="CatalogError.contact" defaultMessage="contact us" />;

    const message = (
        <FormattedMessage
            id="CatalogError.message"
            defaultMessage="There was an issue loading this catalog. Please try refreshing the page. If the issue persists, please {contactLink}."
            values={{
                contactLink: <Link href="/contact/?topic=technicalDifficulties">{contact}</Link>,
            }}
        />
    );

    return (
        <div className={styles.container}>
            <div className={styles.box}>
                <div className={styles.header}>{header}</div>
                <div className={styles.message}>{message}</div>
            </div>
        </div>
    );
};
